module.exports = __webpack_public_path__ + "static/img/bannerBg6_en.272df28.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bannerBg6_en.png
// module id = Qi99
// module chunks = 1